import { ICONS } from '@app/styles';
export const getDispositionAction = (dispoType) => {
    const isAdmit = dispoType === 'admit';
    return {
        label: isAdmit ? 'Admit' : 'Discharge',
        variant: isAdmit ? 'admission' : 'discharge',
        Icon: isAdmit ? ICONS.advisor_avn_admit : ICONS.advisor_avn_discharge,
    };
};
//# sourceMappingURL=disposition-action.js.map